/**
 * Aynı arayüz iki yerde çalışıyor: Electron masaüstü uygulaması ve web
 * uygulaması (app.talknote.net, bkz. vite.web.config.ts). Web derlemesi bu
 * değişkeni tanımlıyor; masaüstünde tanımsız. Derleme anında sabitlendiği için
 * web'e özel dallar masaüstü paketinden atılıyor (ve tersi).
 */
export const IS_WEB = (import.meta as unknown as { env: Record<string, string | undefined> }).env.VITE_TALKNOTE_TARGET === 'web';

/**
 * Mobil uygulama (Capacitor; vite.mobile.config.ts). Mobil paket web paketinin
 * üstüne kurulu: burada IS_WEB de true, web dalları telefonda da geçerli.
 * Yalnızca telefonda farklı olan yerler bu bayrağa bakıyor.
 */
export const IS_NATIVE = (import.meta as unknown as { env: Record<string, string | undefined> }).env.VITE_TALKNOTE_NATIVE === 'true';

/**
 * Tarayıcı sekme sesini paylaşabiliyor mu (Chrome/Edge masaüstü). Firefox ve
 * Safari ekran paylaşımında ses vermiyor; telefonda ekran paylaşımı yok.
 */
export function canCaptureTabAudio(): boolean {
  if (!IS_WEB || typeof navigator === 'undefined') return false;
  if (typeof navigator.mediaDevices?.getDisplayMedia !== 'function') return false;
  const brands = (navigator as Navigator & { userAgentData?: { brands?: Array<{ brand: string }>; mobile?: boolean } }).userAgentData;
  if (brands?.mobile) return false;
  return Boolean(brands?.brands?.some((b) => b.brand === 'Chromium' || b.brand === 'Google Chrome' || b.brand === 'Microsoft Edge'));
}
